import { Component, Input, OnInit } from '@angular/core';
import { Pagination } from '../../../../shared/pagination/pagination';
import { PaginationOptions } from '../../../../shared/pagination/pagination-options';
import { RSJService } from '../../../../shared/services/rsj.service';
import { BeneficiaryDto } from '../../../dto/beneficiary.dto';
import { RsjPaymentInformationDto } from '../../dto/rsj-payment-information.dto';
import { RsjDto } from '../../dto/rsj.dto';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-rsj-payment-information',
  templateUrl: './rsj-payment-information.component.html',
})
export class RsjPaymentInformationComponent implements OnInit {
  @Input() beneficiary: BeneficiaryDto;

  protected readonly destroy$: Subject<void> = new Subject();

  public payments: Pagination<RsjPaymentInformationDto>;
  public nextPayment: RsjPaymentInformationDto;
  public rsjDto: RsjDto = undefined;

  constructor(private readonly rsjService: RSJService) {}

  public async ngOnInit(): Promise<void> {
    this.payments = await this.rsjService.getPayments(this.beneficiary?.id, new PaginationOptions(1, 25));
    this.nextPayment = (this.payments.items || []).filter((payment) => payment.state === 'Prévu').pop();
    this.rsjService.rsj$.pipe(takeUntil(this.destroy$)).subscribe((rsj: RsjDto) => (this.rsjDto = rsj));
    if (!this.rsjDto) {
      await this.rsjService.getRSJ(this.beneficiary.id);
    }
  }

  public async changePage(pageNb?: number): Promise<void> {
    if (pageNb) {
      this.payments = await this.rsjService.getPayments(this.beneficiary.id, new PaginationOptions(pageNb, this.payments?.options?.limit));
    }
  }

  public async changeLimit(event: any): Promise<void> {
    if (event && event.target && event.target.value) {
      const limit: number = event.target.value;
      this.payments = await this.rsjService.getPayments(this.beneficiary.id, new PaginationOptions(1, limit));
    }
  }

  public async updatePaymentInfoStatus(id: number): Promise<void> {
    await this.rsjService.updatePaymentInfoStatus(id);
    this.payments = await this.rsjService.getPayments(this.beneficiary?.id, new PaginationOptions(1, 25));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
